export default {
  'Custom': 'Benutzerdefiniert',
  'Original': 'Original',
  'Resolution': 'Auflösung',
  'Frame rate': 'Bildrate',
  'The higher the frame rate, the smoother the animation': 'Je höher die Bildrate, desto flüssiger die Animation.',
  'Start': 'Starten',
  'End': 'Enden',
  'Create GIF': 'GIF erstellen',
  'Download GIF': 'GIF herunterladen',
  'Create A New One': 'Neues GIF erstellen',
  'Remake GIF': 'GIF erneut erstellen',
  'HitPaw Video to GIF Online': 'HitPaw Video zu GIF online',
  'Upload and convert video to GIF without any difficulty': 'Hochladen und Konvertieren von Videos zu GIF ohne Schwierigkeiten',
}